// calculations based off a default height of 48px from figma
export const FOLDER_HEIGHT = 48;
export const PERCENTAGE = 'percentage';
export const NUMBER = 'number';
export const CURRENCY = 'currency';
export const NULL = 'null';
